import React from "react";

const IndustriesWeServe = () => {
  const iconStyle = {
    fontSize: "36px",
    backgroundColor: "#dc3545",
    color: "#fff",
    width: "60px",
    height: "60px",
    lineHeight: "60px",
    borderRadius: "50%",
    display: "inline-block",
    marginBottom: "15px",
    textAlign: "center",
  };

  const headingStyle = {
    fontSize: "20px",
    fontWeight: "bold",
    color: "#212529",
    marginBottom: "10px",
  };

  const textStyle = {
    fontSize: "15px",
    color: "#495057",
  };

  const industries = [
    {
      icon: "🏥",
      title: "Healthcare",
      text: "We provide secure IT systems for hospitals and clinics to enhance patient care and streamline operations.",
    },
    {
      icon: "💰",
      title: "Finance",
      text: "Our financial IT services boost security, compliance, and performance for banks and fintech firms.",
    },
    {
      icon: "🛍️",
      title: "Retail",
      text: "We develop eCommerce, inventory, and customer solutions to digitize and grow retail businesses.",
    },
    {
      icon: "🎓",
      title: "Education",
      text: "Empowering institutions with online learning systems, virtual classrooms, and smart LMS platforms.",
    },
    {
      icon: "🏭",
      title: "Manufacturing",
      text: "We streamline manufacturing through automation, IoT solutions, and intelligent tracking systems.",
    },
    {
      icon: "🏘️",
      title: "Real Estate",
      text: "From property listing websites to CRM tools, we enable smarter selling and better customer experience.",
    },
  ];

  return (
    <div className="container my-5"
     data-sal-delay="150"
              data-sal="slide-up"
              data-sal-duration="800"
    >
      <h2
        className="text-center mb-5"
        style={{ color: "#dc3545", fontWeight: "bold" }}
      >
        Industries We Serve
      </h2>
      <div className="row">
        {industries.map((industry, index) => (
          <div className="col-lg-4 col-md-6 mb-4" key={index}>
            <div
              className="p-4"
              style={{
                background: "linear-gradient(135deg, #ffffffcc, #f8f9fa)",
                borderRadius: "16px",
                boxShadow: "0 12px 20px rgba(0, 0, 0, 0.1)",
                height: "100%",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-10px)";
                e.currentTarget.style.boxShadow =
                  "0 16px 30px rgba(0, 0, 0, 0.15)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow =
                  "0 12px 20px rgba(0, 0, 0, 0.1)";
              }}
            >
              <div style={iconStyle}>{industry.icon}</div>
              <h4 style={headingStyle}>{industry.title}</h4>
              <p style={textStyle}>{industry.text}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default IndustriesWeServe;
